export default __webpack_public_path__ + "static/media/PPI-driveway-012.06c340af.jpg";